import './ChatBox.scss';
import ChatMessage from '../ChatMessages/ChatMessages';
import ChatInput from '../ChatInput/ChatInput';
import { ChatMessage as ChatMessageType } from '../../../Meeting/MeetingChat/types/MeetingChat.types';

interface propsTypes {
  handleSendMessage:(text: string) => void;
  chatMessages: ChatMessageType[];
  currentUserName:string | undefined;
}

const ChatBox = ({ handleSendMessage, chatMessages, currentUserName}: propsTypes) => {


  return (
    <div className="chat-box">
      <div className="chat-header">
        Chats
      </div>
      <div className="chat-messages">
        {
          chatMessages && chatMessages.map((chats, index) => {
            return <ChatMessage
              message={chats.message}
              userName={chats.name}
              key={index}
              isCurrentUser={currentUserName === chats.name}
            />
          })
        }
      </div>
      <ChatInput onSend={handleSendMessage} />
    </div>
  );
}

export default ChatBox;
